import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { usePostBrandMutation } from '../../../../store/api/barand_master';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1.jsx";
import { useLazyGetStockAccountsByCompanyQuery, useGetCompanyListQuery, useGetParentWarehousesQuery,
useCreateWarehouseMutation, useGetWarehouseOnlyParentDataMutation } from '../../../../store/api/warehousemaster';


function Createwarehouse() {
  const navigate = useNavigate()
  const [tab, settab] = useState(1)
  const [zoneWarehouseList, setzoneWarehouseList] = useState([]);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [postBrand] = usePostBrandMutation();
  const [parentcompany, setparentcompany] = useState([]);
  const [fullcompanylist, setfullcompanylist] = useState([]);
  const [accounts, setaccounts] = useState([]);
  const [formData, setFormData] = useState({
    warehouseName: '',
    parentWarehouse: '',
    company: '',
    account: '',
    abbr: '',
    phoneNo: '',
    mobileNo: '',
    addressLine1: '',
    addressLine2: '',
    county: '',
    stateProvince: '',
    cityTown: '',
    postalCode: '',
    isGroupWarehouse: false,
    isRejectedWarehouse: false
  });

  const { data: companyList } = useGetCompanyListQuery();
  const { data: parent_company } = useGetParentWarehousesQuery();

  useEffect(() => {
    if (parent_company) {
      setparentcompany(parent_company);
    }
    if (companyList) {
      setfullcompanylist(companyList)
    }
  }, [parent_company]);

   

  const [getwarehosuelist] = useGetWarehouseOnlyParentDataMutation();
  useEffect(()=>{
    const getZoneWarehouseData = async () => {
        const res = await getwarehosuelist({
            doctype: '/method/stackerbee_mobile_wms.wms.react_api.get_zone_warehouse_for_bin',
            limit_start: 0,
            limit_page_length: 99999999,
            company:formData.company,
        });
    console.log("check bin is here or not ",res);
    setzoneWarehouseList(res.data?.full_data)
    };
    getZoneWarehouseData();
  },[formData.company])

  
  const handleInputChange = (fieldName, value) => {
    if (["company"].includes(fieldName)) {
      handleSpecialFieldChange(fieldName, value);
    }
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const [triggerGetStockAccounts] = useLazyGetStockAccountsByCompanyQuery();

  const handleSpecialFieldChange = (fieldName, value) => {
    console.log(`Special field changed: ${fieldName} -> ${value}`);

    if (fieldName === "company") {
      triggerGetStockAccounts(value)
        .unwrap()
        .then((data) => {
          console.log("Stock accounts for company:", data);
          setaccounts(data)

        })
        .catch((error) => {
          console.error("Error fetching stock accounts:", error);
        });
    }
  }
  const [createWarehouse, { data, isLoadingthree, errorthree }] = useCreateWarehouseMutation();

  const handleSubmit = async () => {
    // Validate required fields
    if (!formData.warehouseName.trim()) {
      setError('Warehouse Name is required');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      // Prepare complete payload from formData
      const payload = {
        warehouse_name: formData.warehouseName,
        parent_warehouse: formData.parentWarehouse,
        company: formData.company,
        account: formData.account,
        custom_abbr: formData.abbr,
        // phone_no: formData.phoneNo,
        // mobile_no: formData.mobileNo,
        // address_line_1: formData.addressLine1,
        // address_line_2: formData.addressLine2,
        // county: formData.county,
        // state: formData.stateProvince,
        // city: formData.cityTown,
        // pin: formData.postalCode,
        // is_group: formData.isGroupWarehouse || false,
        is_rejected_warehouse: formData.isRejectedWarehouse || false,
      };

      console.log('Submitting payload:', payload);
      createWarehouse(payload);
      // Call your API here
      // const response = await createWarehouse(payload).unwrap();

      setError('Bin created successfully!');
      setptype('Success');
      setShowError(true);
      setTimeout(() => {
        navigate('/master/bin-list')
      }, 1300);

      // Reset form after successful submission if needed
      // setFormData({
      //     warehouseName: '',
      //     parentWarehouse: '',
      //     // ...reset all other fields...
      // });

    } catch (err) {
      setError(err?.data?.message || 'Failed to create warehouse');
      setptype('Error');
      setShowError(true);
    }
  };

  return (
    <>
      <FormLayout
        title="New Bin"
        breadcrumbs={[
          { label: "Master" },
          { label: "Bin List ", url: "/master/bin-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>

            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", height: "500px", flexGrow: '1' }}>
            <div className="row d-flex justify-content-between">
              <div className="col-12" >
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    parentcompany={parentcompany}
                    fullcompanylist={fullcompanylist}
                    accounts={accounts}
                    formData={formData}
                    zoneWarehouseList={zoneWarehouseList}
                    onInputChange={handleInputChange}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayout>
    </>
  )
}

export default Createwarehouse
